module.exports = __webpack_public_path__ + "media/application/images/svgs/airplay-a1333f1a72748efdf8c4fb45e179cd7d.svg";